import { render } from "./WorksStats.vue?vue&type=template&id=75bf5b92"
import script from "./WorksStats.vue?vue&type=script&lang=js"
export * from "./WorksStats.vue?vue&type=script&lang=js"

import "./WorksStats.vue?vue&type=style&index=0&id=75bf5b92&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__